import { useTranslation } from 'react-i18next'
import {
  REGISTRATION_REASON_UNKNOWN_KEY,
  registrationReasonLabel,
} from '../model/registrationReasons'

interface Props {
  reason?: string | null
  className?: string
}

/** Строка «Причина: …»; без причины ничего не рисует, у неизвестной — только
 *  «Причина не указана». */
export function RegistrationReason({ reason, className }: Props) {
  const { t } = useTranslation('participant')
  const { t: tCommon } = useTranslation('common')
  if (!reason) return null
  const label = registrationReasonLabel(reason, tCommon)
  // «Причина: Причина не указана» — тавтология: у неизвестной причины фраза
  // стоит сама, без префикса.
  const isUnknown = label === tCommon(REGISTRATION_REASON_UNKNOWN_KEY)
  return (
    <p className={className}>
      {isUnknown ? label : t('olympiad_detail.reason', { reason: label })}
    </p>
  )
}
